import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { FeatureInformation, getFeatureInformation } from './access-restricted-content';
import { FeatureInfoService } from './feature-info.service';
//import { FeatureInfo, getFeatureInfo } from './restricted-content/restricted-content';

@Component({
  template: `
    <!--    the old restricted pages-->
    <div class="feature" *ngIf="featureInfo$ | async as info" [style.background-image]="backgroundImageUrlSanitized">
      <app-access-restricted-content
        [featureInfo]="info"
        userEventCategory="restricted-page-action"
      ></app-access-restricted-content>
    </div>

    <!--    the new restricted pages-->
    <!--    <div class="feature" *ngIf="featureInfoV2$ | async as info">-->
    <!--      <app-restricted-content [featureInfo]="info"></app-restricted-content>-->
    <!--    </div>-->
  `,
  styleUrls: ['./access.component.scss'],
})
export class AccessRestrictedComponent implements OnInit {
  backgroundImageUrl =
    'url("https://vstatic-prod.apigateway.co/partner-center-client.9223372035141299467.prod/assets/images/restricted-bg.png")';

  // old feature info
  featureInfo$: Observable<FeatureInformation>;
  // new feature info
  //featureInfoV2$: Observable<FeatureInfo>;

  backgroundImageUrlSanitized: SafeStyle;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private readonly featureInfoService: FeatureInfoService,
  ) {}

  ngOnInit(): void {
    let featureId: string;

    // the new restricted pages
    // this.featureInfo$ = this.route.params.pipe(
    //   map((params) => {
    //     featureId = params.featureId;
    //     return getFeatureInfo(featureId);
    //   }),
    // );

    // the old restricted pages
    this.featureInfo$ = this.route.params.pipe(
      switchMap((params) => {
        featureId = params.featureId;
        return this.featureInfoService.getNextSubscriptionTierWithFeature(featureId);
      }),
      map((nextSubscriptionId) => {
        const featureInfo = getFeatureInformation(featureId);
        featureInfo.minUpgradeLevel = nextSubscriptionId;
        return featureInfo;
      }),
    );
    this.backgroundImageUrlSanitized = this.sanitizer.bypassSecurityTrustStyle(this.backgroundImageUrl);
  }
}
